// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2TcwV","productName":"Table_productName__2j7jf"};